// Section content fades in once it scrolls into view. Only the inner
// wrap moves, the section background (tones surface, accent, glow)
// stays in place, so the page never jumps. Sections that are already
// visible on load are left alone, and without JavaScript or with
// prefers-reduced-motion everything simply stays visible.
function initReveal(): void {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    return;
  }
  const wraps = Array.from(document.querySelectorAll<HTMLElement>('main > .th-section > .th-wrap')).filter(
    (wrap) => wrap.getBoundingClientRect().top > window.innerHeight,
  );
  if (wraps.length === 0) {
    return;
  }
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('th-reveal--in');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px' },
  );
  wraps.forEach((wrap) => {
    wrap.classList.add('th-reveal');
    observer.observe(wrap);
  });
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initReveal) : initReveal();
